@if (legendSettings(); as settings) {
  <tm-image-with-description [src]="settings.url" [legendSettings]="settings"/>
}
